// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Meta from 'vue-meta'
import VueMobileDetection from 'vue-mobile-detection'

import VueResource from 'vue-resource'

import EnvironmentPlugin from './plugins/environment'
import ToolPlugin from './plugins/tool'
import LoggerPlugin from './plugins/logger'
import TokenPlugin from './plugins/token'

Vue.use(VueResource)

Vue.use(EnvironmentPlugin)
Vue.use(ToolPlugin)
Vue.use(LoggerPlugin)
Vue.use(TokenPlugin)
Vue.use(Meta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(VueMobileDetection)

Vue.config.productionTip = false

if (Vue.env.isChektDomain && Vue.env.isProduction) {
  Vue.logger.setLogLevel('WARNING') // 'DEBUG', 'INFO', 'WARNING', 'ERROR'
} else {
  Vue.logger.setLogLevel('DEBUG') // 'DEBUG', 'INFO', 'WARNING', 'ERROR'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js